// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlobField_wrapper__1dMCn","popover":"BlobField_popover__ehT8D"};